import {isNil} from 'ramda';

import {Money} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export function moneyToNumber(money: Money | Nullish): number | null {
  if (isNil(money)) {
    return null;
  }

  return Number(money.amount);
}
